// Utilities
import { getDefaultStore } from '../../utility/environmentUtils'

const objFunc = () => {
  return {
    serviceAvailable: true,
    // userIsOnMobileDevice: false, use display/isMobileBrowser instead
    disclosuresLinksList: undefined,
    utmSource: undefined,
    geolocationEnabled: false,
    geolocationAddress: '',
    latitude: undefined,
    longitude: undefined,
    skipRefreshConfirmation: false,
    forceRefreshPage: '',
    errorScanningId: false,
    registrationCountyList: [],
    config: {
      addressSuggestion: true,
      customerServicePhone: '',
      apiCallAttemptLimit: 4,
      sessionId: undefined,
      minAge: 18,
      maxAge: 120,
      footerLinks: [],
      underlinedFooterLinks: [],
      copyrightStatement: '',
      footerConfig: {},
      customerPortalUrl: process.env.VUE_APP_CUSTOMER_PORTAL_URL,
      demographics: [],
      geolocationCheckEnabled: true,
      updateCityStateFromZip: true,
      minBorrowAmount: 100,
      maxBorrowAmount: 25000,
      defaultStoreNumber: getDefaultStore(),
      prescoreApplication: false,
      productCode: '',
      productId: 0,
      disableSelfAppraisal: false,
      showEmploymentLengthQuestions: false,

      /**
       * True if the configurations have been successfully pulled from the API at least once. False if default settings are still set.
       */
      remoteConfigsSaved: false,
      showFlexLoanScreen: false,
      showLoanSelectionScreen: false,

      cppVideoConfig: {
        videoUrl: '',
        subtitlesUrl: ''
      },
      canSendVoiceMessages: false,
      showScanIdScreens: false,
      showScanIdScreensProduct: {
        mobile: false,
        desktop: false
      },
      consentText: {
        signatureText: '',
        smsConsent: '',
        callConsent: '',
        emailConsent: ''
      },
      optionalSsn: false,
      allowAlienRegistrationNumber: false,
      enableMobileMoney: true,
      googleMapsApiKey: undefined,
      showHurricaneModal: false,
      hurricaneModalText: undefined,
      skipCcfiFlow: false,
      resendButtonTimerTimeOut: 10
    },
    showOwnershipScreen: false,
    showLenderInformationScreen: false,
    showCollateralProtection: false,
    idScanned: false,
    editMode: false,
    idScanManualEntry: false,
    editOrigin: undefined,
    showExpensesScreen: false,
    blockedStates: [],
    storeReminderList: '',
    mobileMoneyApprovalInstructions: '',
    storeReminderListFinanced: '',
    storeReminderListCoOwner: '',
    showCoOwnerScreens: false,
    applicationOptions: {
      disableSelfAppraisal: false,
      skipCcfiFlow: false
    },
    appointmentTimeCap: '',
    geolocation: {
      customerState: '',
      nextPageRoute: undefined
    },
    lastDocumentViewed: undefined
  }
}

export default objFunc()

export const defaultObj = objFunc()
